import { cn } from "@/lib/utils";

export function ExpressProgressBar({ currentStep, totalSteps = 3 }) {
  const progress = ((currentStep) / totalSteps) * 100;
  
  return (
    <div className="w-full">
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs text-white/50">
          Step {currentStep} of {totalSteps}
        </span>
        <span className="text-xs text-white/50">
          {Math.round(progress)}%
        </span>
      </div>
      <div className="h-1.5 bg-white/10 rounded-full overflow-hidden">
        <div 
          className={cn(
            "h-full bg-gradient-to-r from-cipher-green to-cipher-green/80 rounded-full",
            "transition-all duration-500 ease-out",
            "shadow-sm shadow-cipher-green/50"
          )}
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
}
